import { css } from '@linaria/core';
import { baseTheme } from 'styles/utils';
export const toggleContainer = "odules__Listings__components__AllStarTemplateToggle__styles_ts-toggleContainer-t18ygr4o";

require("./styles.linaria.module.css!=!../../../../node_modules/@linaria/webpack-loader/node_modules/@linaria/webpack5-loader/lib/outputCssLoader.js!./styles.ts");